module.exports = __webpack_public_path__ + "images/7499d5f70f0616a9bbd1d9e536cef809.svg";